import { __extends, __assign } from 'tslib';
import React__default, { createRef } from 'react';
import clsx from 'clsx';
import { IconX } from '@tabler/icons';
import colors from '../../util/colors.js';
import { Icon } from '../Icon/Icon.component.js';
import { ContextualAlertButton } from '../ContextualAlertButton/ContextualAlertButton.component.js';
import { CloseTimer } from '../CloseTimer/CloseTimer.component.js';
import ButtonBase from '../ButtonBase/ButtonBase.component.js';
import { logger } from '../../util/_internal/logger.js';
import { propTypes, defaultProps } from './Banner.types.js';
import styles from './Banner.module.scss.js';

var SUCCESS = 'success';
var iconMap = {
    success: 'SuccessIcon',
    warning: 'WarningSolidIcon',
    danger: 'DangerSolidIconTriangle',
    informative: 'InformativeSolidIcon',
};
var colorMap = {
    success: colors.success80,
    warning: colors.warning90,
    danger: colors.danger80,
    informative: colors.informative80,
};
var noop = function () {
    /* This handler doesn't do anything */
};
/**
 * Use banners to communicate important or new information to the user.
 */
var Banner = /** @class */ (function (_super) {
    __extends(Banner, _super);
    function Banner(props) {
        var _this = _super.call(this, props) || this;
        _this.messageRef = createRef();
        _this.state = {
            isMultiline: false,
        };
        return _this;
    }
    Banner.prototype.componentDidMount = function () {
        var _a;
        // line-height = 1.3125rem(21px) of our p element styling, that included into .Banner class
        if (Number((_a = this.messageRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) > 21 ||
            this.props.title) {
            this.setState({ isMultiline: true });
        }
        if (this.props.timeout) {
            logger.warn('DEPRECATION WARNING: The `timeout` prop is deprecated and support for it will be removed soon.');
        }
        if (this.props.variant === SUCCESS) {
            logger.warn('DEPRECATION WARNING: The success `variant` prop is deprecated and support for it will be removed soon. If you need to use a success banner. Please have your Designer look into Toast for system messages instead');
        }
        if (this.props.styling) {
            logger.warn('DEPRECATION WARNING: The `styling` prop is deprecated and support for it will be removed soon. Please use `variant` instead.');
        }
    };
    Banner.prototype.render = function () {
        var _a = this.props, message = _a.message, actions = _a.actions, onClick = _a.onClick, onDismiss = _a.onDismiss, buttonText = _a.buttonText, styling = _a.styling, urgent = _a.urgent, className = _a.className, timeout = _a.timeout, hideIcon = _a.hideIcon, title = _a.title, display = _a.display;
        if (!urgent) {
            logger.warn("Prop 'urgent' is deprecated");
        }
        var variant = styling || this.props.variant;
        var hasActions = Boolean(actions);
        var showCloseTimerButton = Number.isFinite(timeout) && onDismiss;
        var showIcon = hideIcon !== undefined ? !hideIcon : !showCloseTimerButton;
        var isMultiline = this.state.isMultiline;
        var showActions = hasActions || (!onDismiss && onClick);
        return (React__default.createElement("div", { "data-testid": this.props['data-testid'], className: clsx(styles.Banner, styles["Banner___".concat(variant)], urgent && styles.Banner___urgent, hasActions && styles.Banner___withActions, className, styles["Banner___".concat(display)]) },
            React__default.createElement("div", { className: clsx(styles.Banner_icon, !isMultiline && styles.IconContainer___alignCenter) }, showIcon && (React__default.createElement(Icon, { size: 22, name: iconMap[variant], alt: variant, className: styles.Icon }))),
            React__default.createElement("div", { className: styles.Content },
                React__default.createElement("div", { className: styles.Content_message },
                    React__default.createElement("div", { className: styles.Content_messageTitle }, title),
                    React__default.createElement("span", { ref: this.messageRef }, message)),
                showActions && (React__default.createElement("div", { className: styles.Actions },
                    hasActions && actions,
                    !hasActions && !onDismiss && onClick && (React__default.createElement(ContextualAlertButton, { onClick: onClick, variant: variant }, buttonText))))),
            React__default.createElement("div", { className: styles.Dismiss },
                onDismiss && !timeout && (React__default.createElement(ButtonBase, { onClick: onDismiss, type: "button", tabIndex: -1, "data-testid": 'close-button', className: styles.Dismiss_button },
                    React__default.createElement(IconX, { color: colors.black, size: 24, stroke: 1.5 }))),
                showCloseTimerButton && (React__default.createElement(CloseTimer, { color: colorMap[variant], duration: timeout || 0, onClick: onDismiss || onClick || noop })))));
    };
    Banner.displayName = 'Banner';
    Banner.propTypes = propTypes;
    Banner.defaultProps = __assign({}, defaultProps);
    return Banner;
}(React__default.Component));

export { SUCCESS, Banner as default };
